import React from 'react'
import PropTypes from 'prop-types'
import { FileInput } from '../FileInput/FileInput'
import { DateInput } from '../DateInput/DateInput'
import { polyglot } from '../../../index'
import { Button } from '../Button/Button'
import RichTextEditor from '../RichTextEditor/RichTextEditor'

class InputsFormGroup extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      activeElement: undefined,
      userInput: false,
      labelSize: props.expandInputArea ? 3 : 6,
      count: 1
    }
    this.renderInputs = this.renderInputs.bind(this)
    this.handleFileChange = this.handleFileChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.createUI = this.createUI.bind(this)
  }
  componentWillMount () {
    // if (this.props.savedData) {
    //   this.props.fields.forEach(function (element) {
    //     if (typeof (this.props.savedData) === 'object') {
    //       Object.keys(this.props.savedData).forEach(key => {
    //         this.setState({
    //           [key]: this.props.savedData[key]
    //         })
    //       })
    //     } else {
    //       this.setState({
    //         [element.name]: this.props.savedData
    //       })
    //     }
    //   }.bind(this))
    // }
    if (this.props.savedData) {
      this.props.fields.forEach(element => {
        if (this.props.savedData !== null && typeof (this.props.savedData) === 'object') {
          Object.keys(this.props.savedData).forEach(key => {
            if (key !== this.state.activeElement) {
              this.setState({
                [key]: this.props.savedData[key]
              })
            }
          })
        } else {
          if (!this.state.activeElement) {
            this.handleAutomaticInput(element.name, this.props.savedData)
            this.setState({
              [element.name]: this.props.savedData
            })
          }
        }
      })
    }
  }

  componentWillReceiveProps (props) {
    if (!this.state.userInput) {
      if (this.props.savedData !== props.savedData) {
        props.fields.forEach(element => {
          if (props.savedData !== null && typeof (props.savedData) === 'object') {
            Object.keys(props.savedData).forEach(key => {
              if (key !== this.state.activeElement) {
                this.setState({
                  [key]: props.savedData[key]
                })
              }
            })
          } else {
            if (!this.state.activeElement) {
              this.handleAutomaticInput(element.name, props.savedData)
              this.setState({
                [element.name]: props.savedData
              })
            }
          }
        })
      }
    }
  }

  handleAutomaticInput (name, value) {
    this.props.getFieldValue(name, value)
  }

  handleUserInput () {
    this.setState({
      userInput: true
    })
  }

  handleChangeInput (name, value) {
    this.setState({
      activeElement: name,
      [name]: value
    }, () => {
      this.props.getFieldValue(name, value)
    })
  }

  handleDateChange (name, value) {
    this.setState({
      [name]: value
    }, () => {
      this.props.getFieldValue(name, value)
    })
  }

  handleFileChange (name, value) {
    this.setState({
      [name]: value
    }, () => {
      this.props.getFieldValue(name, value)
    })
  }

  renderInputs (counter) {
    let size = Math.floor((12 - this.state.labelSize) / this.props.fields.length)
    if (size < 1) {
      size = 1
    }
    return this.props.fields.map(function (element, index) {
      if (element.type === 'textarea') {
        size = 9
      }
      if (!element.hasOwnProperty('required')) {
        element['required'] = false
      }
      if (!element.hasOwnProperty('readOnly')) {
        element['readOnly'] = false
      }
      if (element.type === 'image' || element.type === 'pdf') {
        return <div key={index} className={`col-sm-${size}`}>
          <FileInput multiple={element.multiple} savedValue={this.state[element.name]} handleSubmit={this.handleFileChange} type={element.type} required={element.required} placeholder={element.placeholder} name={element.name} />
        </div>
      } else if (element.type === 'date') {
        return <div key={index} className={`col-sm-${size}`}>
          <DateInput
            minDate={this.props.minDateForCalendar}
            maxDate={this.props.maxDateForCalendar}
            name={element.name}
            handleChange={this.handleDateChange}
            required={element.required}
            placeholder={element.placeholder}
            readOnly={element.readOnly}
            value={this.state[element.name] || ''} />
        </div>
      } else if (element.type === 'textarea') {
        return <div key={index}>
          <div className={`col-sm-${size}`}>
            <RichTextEditor
              value={this.state[element.name]}
              readOnly={element.readOnly}
              required={element.required}
              onChange={(value) => this.handleChangeInput(element.name, value)}
              placeholder={polyglot.t(element.placeholder)} />
            {/* <textarea readOnly={element.readOnly} */}
            {/* required={element.required} */}
            {/* name={element.name} */}
            {/* value={this.state[element.name] || ''} */}
            {/* placeholder={polyglot.t(element.placeholder)} */}
            {/* onChange={(e) => this.handleChangeInput(e.target.name, e.target.value)} */}
            {/* className='form-control custom-textarea' rows='8' /> */}
          </div>
        </div>
      } else if (element.type) {
        let name = element.name
        let value = this.state[element.name] || ''
        if (counter) {
          value = this.state[`${element.name}`][counter] || ''
          name = element.name + '_' + counter
        }
        return <div key={`${index}_${counter}`}>
          <div className={`col-sm-${size}`}>
            <input onKeyDown={this.handleUserInput.bind(this)}
              readOnly={element.readOnly}
              required={element.required}
              name={name}
              value={value}
              placeholder={polyglot.t(element.placeholder)}
              onChange={(e) => this.handleChangeInput(e.target.name, e.target.value)}
              type={element.type}
              className='form-control' />
          </div>
        </div>
      }
    }.bind(this))
  }

  createUI () {
    let uiItems = []
    for (let i = 0; i < this.state.count; i++) {
      uiItems.push(
        this.renderInputs(i)
      )
    }
    return uiItems || null
  }

  // addClick () {
  //   this.setState({
  //     count: this.state.count + 1
  //   })
  // }

  render () {
    return <div className='form-group'>
      <label className={`col-xs-12 col-sm-${this.state.labelSize} control-label`}>{polyglot.t(this.props.label)}</label>
      {/* <div className={this.props.multipleInput ? 'col-xs-10 col-sm-7' : null}> */}
      {this.createUI()}
      {/* </div> */}
      {/* {this.props.multipleInput ? <div className={'col-xs-2 col-sm-1 pull-right'}> */}
      {/* <Button */}
      {/* onClick={this.addClick.bind(this)} */}
      {/* text={'+'} */}
      {/* buttonType='btn btn-primary btn-block' */}
      {/* type={'button'} /> */}
      {/* </div> : null} */}
    </div>
  }
}

InputsFormGroup.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      required: PropTypes.bool,
      name: PropTypes.string.isRequired,
      placeholder: PropTypes.string,
      type: PropTypes.string.isRequired})).isRequired,
  label: PropTypes.string.isRequired,
  getFieldValue: PropTypes.func.isRequired,
  savedData: PropTypes.oneOfType(
    [PropTypes.string, PropTypes.object, PropTypes.number]),
  minDateForCalendar: PropTypes.string,
  maxDateForCalendar: PropTypes.string
}

class MultipleInnerTextInput extends React.Component {
  constructor (props) {
    super(props)
    let value = props.savedData
    if (value === '') {
      value = []
    }
    this.state = {
      value: value,
      count: props.savedData.length || 1
    }
    this.handleDateInputChange = this.handleDateInputChange.bind(this)
  }

  handleChange (i, event) {
    let value = this.state.value.slice()
    value[i] = event.target.value
    if (value[i] === '') {
      value[i] = null
      if (this.state.count > 1) {
        this.setState({
          count: this.state.count - 1
        })
      }
    }
    this.setState({
      value
    }, this.props.handleChange(this.props.name, value))
  }

  handleDateInputChange (name, val) {
    let value = this.state.value.slice()
    value[name] = val
    if (value[name] === '') {
      value[name] = null
      if (this.state.count > 1) {
        this.setState({
          count: this.state.count - 1
        })
      }
    }
    this.setState({
      value
    }, this.props.handleChange(this.props.name, value))
  }

  addClick () {
    this.setState({count: this.state.count + 1})
  }

  createUI () {
    let uiItems = []
    for (let i = 0; i < this.state.count; i++) {
      uiItems.push(
        <div key={i}>
          {this.props.fieldType === 'date'
            ? <DateInput
              handleChange={this.handleDateInputChange}
              name={`${i}`} value={this.state.value[i] || undefined}
              placeholder={this.props.placeholder}
              required={this.state.count === 1} />
            : <input
              required={this.state.count === 1}
              value={this.state.value[i] || ''}
              onChange={this.handleChange.bind(this, i)}
              placeholder={this.props.placeholder}
              type={this.props.fieldType}
              className='form-control'
              style={{float: 'right'}} />
          }
        </div>
      )
    }
    return uiItems || null
  }

  render () {
    return <div style={{float: 'right'}} ref='innerContainer'>
      {this.createUI()}
      <div className='col-xs-12 no-padding' style={{float: 'right', marginTop: '2px'}}>
        <Button
          onClick={this.addClick.bind(this)}
          text={'+'}
          buttonType='btn btn-primary btn-block'
          type={'button'} />
      </div>
    </div>
  }
}

MultipleInnerTextInput.propTypes = {
  handleChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  expandInputArea: PropTypes.bool,
  fieldType: PropTypes.string.isRequired,
  savedData: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
}

export {InputsFormGroup}



// WEBPACK FOOTER //
// ./src/components/common/InputsFormGroup/InputsFormGroup.js